import OrgBackground from '../../../../assets/backgrounds/bg.jpg';

import { Pill } from '@capra/core';
import styled from 'styled-components';
export const ContextWrapper = styled.div`
  display: flex;
  gap: var(--cds-spacing-md);
  align-items: center;
  font-size: 12px;
  height: 16px;

  > a {
    display: flex;
  }
`;

export const Header = styled.header`
  background-color: rgba(245, 245, 245, 1);
  color: rgba(0, 0, 0, 0.45);
  height: 40px;
  display: flex;
  grid-area: header;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  z-index: 10;
`;

export const ListingOrganizationPage = styled.div`
  background-image: url(${OrgBackground.src});
  padding: 0px;
  display: flex;
  background-repeat: repeat-y;
  background-position: center;
  background-size: cover;
  justify-content: space-between;
  grid-column: 1 / -1;
`;

export const NonProductionTag = styled(Pill)`
  border-radius: 4px;
  color: #333;
  padding: 0 16px;
`;

export const SideBar = styled.div`
  background-color: rgba(245, 245, 245, 1);
  border-right: 1px solid #f0f0f0;
  grid-area: sidebar;
  justify-self: stretch;
  display: flex;
  justify-content: space-between;
  flex-direction: column;
`;
